module.exports = __webpack_public_path__ + "img/php.576b9497.svg";